import { useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import CancelReasonPicker from "@/components/plus/CancelReasonPicker";

export default function CancelDialog({ onConfirm, onClose, busy }) {
  const { t } = useTranslation();
  const [code, setCode] = useState("");
  const [text, setText] = useState("");
  const confirm = () => {
    const c = code === "other" && !text.trim() ? "no_answer" : code || "no_answer";
    onConfirm({ reason_code: c, reason_text: c === "no_answer" ? "" : text.trim() });
  };
  return createPortal(
    <div className="fixed inset-0 z-[70] bg-black/50 flex items-end sm:items-center justify-center sm:p-6" data-testid="cancel-dialog" onClick={onClose}>
      <div className="bg-surface w-full sm:max-w-md rounded-t-3xl sm:rounded-3xl p-5 space-y-3 max-h-[92vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <h3 className="font-display text-2xl">{t("cancel.title")}</h3>
        <p className="text-sm text-text-secondary">{t("cancel.desc")}</p>
        <p className="text-sm font-semibold">{t("cancel.why")}</p>
        <CancelReasonPicker code={code} text={text} onCode={setCode} onText={setText} />
        {code === "other" && !text.trim() && <p className="text-[11px] text-text-secondary">{t("cancel.other_hint")}</p>}
        <button type="button" disabled={busy} onClick={confirm} className="w-full py-3 rounded-xl bg-red-600 text-white font-semibold disabled:opacity-50" data-testid="cancel-dialog-confirm">{t("cancel.confirm")}</button>
        <button type="button" onClick={onClose} className="w-full h-11 text-sm font-semibold text-text-secondary" data-testid="cancel-dialog-close">{t("cancel.keep")}</button>
      </div>
    </div>,
    document.body
  );
}
